import { createAsyncThunk } from "@reduxjs/toolkit"
import apiCall from "../../backend/http"

export const fetchPricingCategories = createAsyncThunk(
  "price/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/pricelist/pricing-categories/")
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createPricingCategory = createAsyncThunk(
  "price/createCategory",
  async (categoryData, { rejectWithValue }) => {
    try {
      const response = await apiCall.post(
        "/api/pricelist/pricing-categories/",
        categoryData
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updatePricingCategory = createAsyncThunk(
  "price/updateCategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCall.put(
        `/api/pricelist/pricing-categories/${id}/`,
        data
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deletePricingCategory = createAsyncThunk(
  "price/deleteCategory",
  async (id, { rejectWithValue }) => {
    try {
      await apiCall.delete(`/api/pricelist/pricing-categories/${id}/`)
      return id
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchPricingGroups = createAsyncThunk(
  "price/fetchGroups",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/pricelist/pricing-groups/")
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createPricingGroup = createAsyncThunk(
  "price/createGroup",
  async (groupData, { rejectWithValue }) => {
    try {
      const response = await apiCall.post(
        "/api/pricelist/pricing-groups/",
        groupData
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updatePricingGroup = createAsyncThunk(
  "price/updateGroup",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCall.put(
        `/api/pricelist/pricing-groups/${id}/`,
        data
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deletePricingGroup = createAsyncThunk(
  "price/deleteGroup",
  async (id, { rejectWithValue }) => {
    try {
      await apiCall.delete(`/api/pricelist/pricing-groups/${id}/`)
      return id
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchPriceLists = createAsyncThunk(
  "price/fetchPriceLists",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/pricelist/price-lists/", {
        params: filters
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createPriceList = createAsyncThunk(
  "price/createPriceList",
  async (priceListData, { rejectWithValue }) => {
    try {
      const response = await apiCall.post(
        "/api/pricelist/price-lists/",
        priceListData
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updatePriceList = createAsyncThunk(
  "price/updatePriceList",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCall.put(
        `/api/pricelist/price-lists/${id}/`,
        data
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deletePriceList = createAsyncThunk(
  "price/deletePriceList",
  async (id, { rejectWithValue }) => {
    try {
      await apiCall.delete(`/api/pricelist/price-lists/${id}/`)
      return id
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchPriceListDetails = createAsyncThunk(
  "price/fetchPriceListDetails",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/pricelist/price-list-details/", {
        params: filters
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createPriceListDetail = createAsyncThunk(
  "price/createPriceListDetail",
  async (detailData, { rejectWithValue }) => {
    try {
      const response = await apiCall.post(
        "/api/pricelist/price-list-details/",
        detailData
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updatePriceListDetail = createAsyncThunk(
  "price/updatePriceListDetail",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCall.put(
        `/api/pricelist/price-list-details/${id}/`,
        data
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deletePriceListDetail = createAsyncThunk(
  "price/deletePriceListDetail",
  async (id, { rejectWithValue }) => {
    try {
      await apiCall.delete(`/api/pricelist/price-list-details/${id}/`)
      return id
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const assignPricelistToCustomer = createAsyncThunk(
  "pricelist/assignToCustomer",
  async ({ userId, pricelistId }, { rejectWithValue }) => {
    try {
      const { data } = await apiCall.post(
        `/api/user-verification/${userId}/assign-pricelist/`,
        {
          price_list_id: pricelistId,
          user_id: userId
        }
      )
      return data
    } catch (error) {
      if (!error.response) {
        return rejectWithValue({
          message: "Network error - please check your connection",
          status: "ERROR",
          details: error.message
        })
      }

      return rejectWithValue({
        message: error.response.data.message || "Failed to assign price list",
        status: error.response.status,
        details: error.response.data
      })
    }
  }
)

export const fetchUsersByPriceList = createAsyncThunk(
  "price/fetchUsersByPriceList",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/pricelist/users-by-pricelist/", {
        params: filters
      })
      return response.data
    } catch (error) {
      if (!error.response) {
        return rejectWithValue({
          message: "Network error - please check your connection",
          status: "ERROR",
          details: error.message
        })
      }

      return rejectWithValue({
        message:
          error.response.data.message || "Failed to fetch users by price list",
        status: error.response.status,
        details: error.response.data
      })
    }
  }
)
